<div class="wrapper">
  <section
    class="sticky top-0 z-10 flex justify-between items-center bg-white border-2 border-b-indigo-800"
  >
    <div>
      <h5 class="flex-1" matDialogTitle>{{ data.ppa.name }} Reviews</h5>
      <p class="text-sm text-gray-500 ms-4">
        {{ data.ppa.type_of_ppa }}

        <br>
        {{ ppaPlace(data.ppa.Locations?.[0]) }}

        <br>
        {{ data.ppa.Locations?.[0]?.address }}
      </p>
    </div>
    <button
      class="mx-5"
      type="button"
      mat-icon-button
      (click)="close()"
      title="Close dialog"
    >
      <mat-icon fontIcon="close" aria-label="close icon"></mat-icon>
    </button>
  </section>

  <!--
    1. Card cause you can like a review, or even reply to it.
    2. We should display the age of the review, easier to digest.
    -->
  <section details-section class="flex-1 flex flex-col gap-4 p-3 overflow-auto">
    
        <!-- TODO: try to make the "REVIEWS" headers stick to the top -->
      <h5 class="font-bold">REVIEWS</h5>

      <div *ngIf="loading" class="flex justify-center py-8" aria-busy="true" aria-label="Loading reviews">
        <mat-spinner diameter="32"></mat-spinner>
      </div>

      <div *ngIf="!loading && loadFailed" class="flex flex-col items-center gap-2 py-8 text-center">
        <p class="m-0 text-sm text-text-secondary" role="alert">Couldn't load this PPA's reviews.</p>
        <button type="button" mat-stroked-button color="primary" (click)="loadFirstPage()">
          <mat-icon aria-hidden="true">refresh</mat-icon> Try again
        </button>
      </div>

      <p *ngIf="!loading && !loadFailed && !reviewPager.reviews.length" class="m-0 py-8 text-center text-sm text-text-secondary">
        No reviews yet.
      </p>

      <mat-card *ngFor="let review of reviewPager.reviews; trackBy: trackByReviewId" [attr.data-review-id]="review.id" tabindex="-1"
        class="focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/40">

        <!-- @todo: make review card a component -->
        <mat-card-header>
          <mat-card-subtitle>
            Review by {{ review.CorpMember ? (review.CorpMember?.nickname ?? review.CorpMember?.first_name) : 'Anonymous' }} ({{ review._age }},
            {{ review.created_at | date : 'd/M/yy' }})</mat-card-subtitle
          >
        </mat-card-header>
        <mat-card-content>
          {{ review.comment }}
          <br *ngIf="review.comment" />
          <div class="start-rating-div" *ngIf="review.star_rating">
            <mat-icon
              class="w-5 h-5 text-xl"
              *ngFor="let star of review.star_rating | starRating"
              [fontIcon]="star ? 'star' : 'star_border'"
              aria-label="star icon"
              color="secondary"
            ></mat-icon>
          </div>
        </mat-card-content>
      </mat-card>

      <app-ppa-reviews-more *ngIf="!loading" [pager]="reviewPager" [total]="reviewCount" (loaded)="focusReview($event)"></app-ppa-reviews-more>
    
  </section>
</div>
